import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "fixed z-40 h-full w-full top-20 left-0" }
const _hoisted_2 = { class: "max-w-480px w-full" }
const _hoisted_3 = { class: "bg-permaBlack5 rounded-3xl p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "rounded-3xl banner_bg overflow-hidden" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "welcomeBanner",
    style: {"height":"248px"}
  })
], -1)
const _hoisted_5 = { class: "mt-8 font-space-gtotesk-bold text-36px text-center" }


import ModalMask from './ModalMask.vue'
interface Props {
  visible:boolean
  title: string
  confirm: string
}
interface Emits {
  (e: 'close'):void
}

export default /*#__PURE__*/_defineComponent({
  props: {
    visible: null,
    title: null,
    confirm: null
  },
  emits: ["close"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'close'):void
}), expose: any, slots: any, attrs: any }) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, { name: "fade" }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createVNode(ModalMask, {
          visible: __props.visible,
          class: "top-20",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (emits('close')), ["self"]))
        }, null, 8, ["visible"]),
        _createElementVNode("div", {
          class: "top-20 pt-10 flex flex-col items-center w-full fixed h-full welcomeScroll-area overflow-y-auto z-30 px-8 md:px-0 transform pb-24",
          onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (emits('close')), ["self"]))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("div", _hoisted_5, _toDisplayString(__props.title), 1),
              _renderSlot(_ctx.$slots, "msg"),
              _renderSlot(_ctx.$slots, "default"),
              _createElementVNode("div", {
                class: "border border-permaGreen4 border-opacity-25 text-permaGreen4 hover:text-permaGreen11 active:text-permaGreen9 transition-colors rounded-xl py-3 w-full text-center cursor-pointer",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
              }, _toDisplayString(__props.confirm), 1)
            ])
          ])
        ])
      ], 512), [
        [_vShow, __props.visible]
      ])
    ]),
    _: 3
  }))
}
}

})